import { ManageBuildingComponent } from './../../modules/manage-building/manage-building.component';
import { MaterialModule } from './../../shared/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { ManagePeriodComponent } from './../../modules/manage-period/manage-period.component';
import { ManageMunicipalityComponent } from './../../modules/manage-municipality/manage-municipality.component';
import { ManagementComponent } from './../../modules/management/management.component';
import { PeriodsComponent } from './../../modules/periods/periods.component';
import { MunicipalitiesComponent } from './../../modules/municipalities/municipalities.component';
import { SharedModule } from './../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { DashboardComponent } from './../../modules/dashboard/dashboard.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultComponent } from './default.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ManageUserComponent } from '../../modules/manage-user/manage-user.component';

@NgModule({
  declarations: [
    DefaultComponent,
    DashboardComponent,
    MunicipalitiesComponent,
    PeriodsComponent,
    ManagementComponent,
    ManageMunicipalityComponent,
    ManagePeriodComponent,
    ManageUserComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    SharedModule,
    TranslateModule,
  ],
  entryComponents: [
    ManageMunicipalityComponent,
    ManagePeriodComponent,
    ManageUserComponent,
  ],
  exports: [],
})
export class DefaultModule {}
